import { faExclamation } from "@fortawesome/pro-solid-svg-icons";

import { UISubscriptionStatus } from "common/types";

import Status from "client/common/components/content/Status";

import { getColorForSubscriptionStatus, getLabelForSubscriptionStatus } from "../utils";

type SubscriptionStatusProps = { subscription: { visible_status: UISubscriptionStatus } };

const SubscriptionStatus = ({ subscription }: SubscriptionStatusProps) => {
  return (
    <Status color={getColorForSubscriptionStatus(subscription.visible_status)}>
      {getLabelForSubscriptionStatus(subscription.visible_status)}
    </Status>
  );
};

const SubscriptionStatusIcon = ({ subscription }: SubscriptionStatusProps) => {
  return (
    <Status.Icon
      color={getColorForSubscriptionStatus(subscription.visible_status)}
      icon={faExclamation}
    />
  );
};

export default Object.assign(SubscriptionStatus, { Icon: SubscriptionStatusIcon });
